<script>
   /***************************************************************
    * PlotTypeSelector                                            *
    * --------------------                                        *
    * control element for selecting a plot type                   *
    ***************************************************************/

   import Container from './Container.svelte';
   import Select from './Select.svelte';

   export let value = 'p';                                     // default plot type
   export let plotTypeOptions = ['p', 'l', 'b', 'h', 'ml'];    // list of types to show
</script>


<Container label='Plot type'>
   <Select id='plotType' className="file-selector" bind:value={value} options={plotTypeOptions} />
</Container>

<style>
   :global(.file-selector > .option) {
      width: 36px;
      height: 22px;
      background-size: 32px 18px;
      background-repeat: no-repeat;
      background-position: 50%;
      font-size: 0;
      border-radius: 2px;
      margin-right: 3px;
   }

   :global(.file-selector > .option:not(.selected):hover) {
      border-color: #6eb8ff20;
   }

   /*
   colors:
   %23606060
   %23fefefe
   %236EB8FF
   */

   :global(.file-selector .option_bp) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="15" width="10" height="16" transform="rotate(-90 8 15)" stroke="%23606060" stroke-width="2"/><line x1="15" y1="14" x2="15" y2="4" stroke="%23606060" stroke-width="2"/><line x1="30" y1="10" x2="25" y2="10" stroke="%23606060" stroke-width="2"/><line x1="8" y1="10" x2="2" y2="10" stroke="%23606060" stroke-width="2"/></svg>');
   }

   :global(.file-selector .option_bp.selected:hover, .file-selector .option_bp.selected) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="15" width="10" height="16" transform="rotate(-90 8 15)" stroke="%23fefefe" stroke-width="2"/><line x1="15" y1="14" x2="15" y2="4" stroke="%23fefefe" stroke-width="2"/><line x1="30" y1="10" x2="25" y2="10" stroke="%23fefefe" stroke-width="2"/><line x1="8" y1="10" x2="2" y2="10" stroke="%23fefefe" stroke-width="2"/></svg>');
   }

   :global(.file-selector .option_bp:hover) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="15" width="10" height="16" transform="rotate(-90 8 15)" stroke="%236EB8FF" stroke-width="2"/><line x1="15" y1="14" x2="15" y2="4" stroke="%236EB8FF" stroke-width="2"/><line x1="30" y1="10" x2="25" y2="10" stroke="%236EB8FF" stroke-width="2"/><line x1="8" y1="10" x2="2" y2="10" stroke="%236EB8FF" stroke-width="2"/></svg>');
   }


   /* heat map */
   :global(.file-selector .option_hm) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="16" width="12" height="23" transform="rotate(-90 5 16)" stroke="%23606060" stroke-width="2"/><line x1="13" y1="16" x2="13" y2="3" stroke="%23606060" stroke-width="2"/><line x1="21" y1="16" x2="21" y2="3" stroke="%23606060" stroke-width="2"/><line x1="28" y1="10" x2="5" y2="10" stroke="%23606060" stroke-width="2"/></svg>');
   }

   :global(.file-selector .option_hm.selected:hover),
   :global(.file-selector .option_hm.selected) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="16" width="12" height="23" transform="rotate(-90 5 16)" stroke="%23fefefe" stroke-width="2"/><line x1="13" y1="16" x2="13" y2="3" stroke="%23fefefe" stroke-width="2"/><line x1="21" y1="16" x2="21" y2="3" stroke="%23fefefe" stroke-width="2"/><line x1="28" y1="10" x2="5" y2="10" stroke="%23fefefe" stroke-width="2"/></svg>');
   }

   :global(.file-selector .option_hm:hover) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="16" width="12" height="23" transform="rotate(-90 5 16)" stroke="%236EB8FF" stroke-width="2"/><line x1="13" y1="16" x2="13" y2="3" stroke="%236EB8FF" stroke-width="2"/><line x1="21" y1="16" x2="21" y2="3" stroke="%236EB8FF" stroke-width="2"/><line x1="28" y1="10" x2="5" y2="10" stroke="%236EB8FF" stroke-width="2"/></svg>');
   }


   /* line */
   :global(.file-selector .option_l) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.23178 14.3598L15.5 5" stroke="%23606060" stroke-width="2"/><line x1="14.4846" y1="5.17692" x2="26.4846" y2="10.1769" stroke="%23606060" stroke-width="2"/></svg>');
   }

   :global(.file-selector .option_l.selected:hover),
   :global(.file-selector .option_l.selected) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.23178 14.3598L15.5 5" stroke="%23326a9e" stroke-width="2"/><line x1="14.4846" y1="5.17692" x2="26.4846" y2="10.1769" stroke="%23326a9e" stroke-width="2"/></svg>');
   }

   :global(.file-selector .option_l:hover) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.23178 14.3598L15.5 5" stroke="%236EB8FF" stroke-width="2"/><line x1="14.4846" y1="5.17692" x2="26.4846" y2="10.1769" stroke="%236EB8FF" stroke-width="2"/></svg>');
   }


   /* scatter */
   :global(.file-selector .option_p) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="12.5" r="2.5" fill="%23606060"/><circle cx="15.5" cy="6.5" r="2.5" fill="%23606060"/><circle cx="23.5" cy="10.5" r="2.5" fill="%23606060"/></svg>');
   }

   :global(.file-selector .option_p.selected:hover),
   :global(.file-selector .option_p.selected) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="12.5" r="2.5" fill="%23326a9e"/><circle cx="15.5" cy="6.5" r="2.5" fill="%23326a9e"/><circle cx="23.5" cy="10.5" r="2.5" fill="%23326a9e"/></svg>');
   }

   :global(.file-selector .option_p:hover) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="12.5" r="2.5" fill="%236EB8FF"/><circle cx="15.5" cy="6.5" r="2.5" fill="%236EB8FF"/><circle cx="23.5" cy="10.5" r="2.5" fill="%236EB8FF"/></svg>');
   }

  /* line-scatter */
   :global(.file-selector .option_b) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.23178 14.3598L15.5 5" stroke="%23606060" stroke-width="1.5"/><line x1="14.4846" y1="5.17692" x2="26.4846" y2="10.1769" stroke="%23606060" stroke-width="1.5"/><circle cx="6.2" cy="12.8" r="2.5" fill="%23606060"/><circle cx="15.5" cy="6.0" r="2.5" fill="%23606060"/><circle cx="25.8" cy="10.5" r="2.5" fill="%23606060"/></svg>');
   }

   :global(.file-selector .option_b.selected:hover),
   :global(.file-selector .option_b.selected) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.23178 14.3598L15.5 5" stroke="%23326a9e" stroke-width="2"/><line x1="14.4846" y1="5.17692" x2="26.4846" y2="10.1769" stroke="%23326a9e" stroke-width="2"/><circle cx="6.2" cy="12.8" r="2.5" fill="%23326a9e"/><circle cx="15.5" cy="6.0" r="2.5" fill="%23326a9e"/><circle cx="25.8" cy="10.5" r="2.5" fill="%23326a9e"/></svg>');
   }

   :global(.file-selector .option_b:hover) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.23178 14.3598L15.5 5" stroke="%236EB8FF" stroke-width="2"/><line x1="14.4846" y1="5.17692" x2="26.4846" y2="10.1769" stroke="%236EB8FF" stroke-width="2"/><circle cx="6.2" cy="12.8" r="2.5" fill="%236EB8FF"/><circle cx="15.5" cy="6.0" r="2.5" fill="%236EB8FF"/><circle cx="25.8" cy="10.5" r="2.5" fill="%236EB8FF"/></svg>');
   }

   /* bar */
   :global(.file-selector .option_h) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="9" y1="15" x2="9" y2="9" stroke="%23606060" stroke-width="6"/><line x1="17" y1="15" x2="17" y2="3" stroke="%23606060" stroke-width="6"/><line x1="25" y1="15" x2="25" y2="7" stroke="%23606060" stroke-width="6"/></svg>');
   }

   :global(.file-selector .option_h.selected:hover),
   :global(.file-selector .option_h.selected) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="9" y1="15" x2="9" y2="9" stroke="%23326a9e" stroke-width="6"/><line x1="17" y1="15" x2="17" y2="3" stroke="%23326a9e" stroke-width="6"/><line x1="25" y1="15" x2="25" y2="7" stroke="%23326a9e" stroke-width="6"/></svg>');
   }

   :global(.file-selector .option_h:hover) {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="9" y1="15" x2="9" y2="9" stroke="%236EB8FF" stroke-width="6"/><line x1="17" y1="15" x2="17" y2="3" stroke="%236EB8FF" stroke-width="6"/><line x1="25" y1="15" x2="25" y2="7" stroke="%236EB8FF" stroke-width="6"/></svg>');
   }

</style>